export const ARQUIVO_SIC_FISICO = 'ARQUIVO_SIC_FISICO';
export const ARQUIVO_SIC_FISICO_SUCCESS = 'ARQUIVO_SIC_FISICO_SUCCESS';
export const ARQUIVO_SIC_FISICO_ERROR = 'ARQUIVO_SIC_FISICO_ERROR';
export const ARQUIVO_SIC_FISICO_START = 'ARQUIVO_SIC_FISICO_START';

export const MENSAGEM_SIC_FISICO = 'MENSAGEM_SIC_FISICO';
export const MENSAGEM_SIC_FISICO_SUCCESS = 'MENSAGEM_SIC_FISICO_SUCCESS';
export const MENSAGEM_SIC_FISICO_ERROR = 'MENSAGEM_SIC_FISICO_ERROR';
export const MENSAGEM_SIC_FISICO_START = 'MENSAGEM_SIC_FISICO_START';
